/**
 * useLLMCosts Hooks
 * React Query hooks for LLM cost data
 */

import { useQuery } from '@tanstack/react-query';
import llmCostService from '../services/llmCostService';

/**
 * Hook for platform-wide LLM costs
 */
export function usePlatformLLMCosts(period = 'monthly', start, end) {
  return useQuery({
    queryKey: ['llm-costs-platform', period, start, end],
    queryFn: () => llmCostService.getPlatformCosts(period, start, end),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

/**
 * Hook for tenant LLM costs
 */
export function useTenantLLMCosts(tenantId, period = 'monthly', start, end, model) {
  return useQuery({
    queryKey: ['llm-costs-tenant', tenantId, period, start, end, model],
    queryFn: () => llmCostService.getTenantCosts(tenantId, period, start, end, model),
    enabled: !!tenantId,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
}

/**
 * Hook for tenant LLM audit trail
 */
export function useLLMAuditTrail(tenantId, start, end, limit = 100, offset = 0) {
  return useQuery({
    queryKey: ['llm-audit', tenantId, start, end, limit, offset],
    queryFn: () => llmCostService.getAuditTrail(tenantId, start, end, limit, offset),
    enabled: !!tenantId,
    staleTime: 1 * 60 * 1000, // 1 minute
  });
}
